module.exports = {
  IN: '0aYaeytSRCgDPQeeF0SqHzWUSNrG2-vRFOkgqIfS1xU',
  LK: 'TBoYmS5h1-1h6KB927_jjdcDtxMUqP6gLcAfWsRFtbE',
  BG: '0aYaeytSRCgDPQeeF0SqHzWUSNrG2-vRFOkgqIfS1xU'
}